import { useDispatch, useSelector } from 'react-redux'
import { Loader2, CheckCircle2, AlertTriangle, WifiOff, ChevronUp, X } from 'lucide-react'
import { setStaticSyncMinimized, clearStaticSync } from '../slice/sharepointSlice'
import { useThemeColor } from '../hooks/useThemeColor'
import { useTranslation } from '../i18n/LanguageContext'

export default function StaticSyncPill() {
  const dispatch = useDispatch()
  const { aispaceColor } = useThemeColor()
  const { t } = useTranslation()
  const { staticSyncPhase, staticSyncSite, staticSyncMinimized, staticSyncProgress, staticSyncConnectionLost } = useSelector(s => s.sharepoint)

  if (staticSyncPhase === 'idle' || !staticSyncSite || !staticSyncMinimized) return null

  const pct = staticSyncProgress?.total > 0
    ? Math.round((staticSyncProgress.processed / staticSyncProgress.total) * 100)
    : null

  return (
    <div className="fixed bottom-6 right-6 select-none" style={{ zIndex: 9999 }}>
      <div
        className="flex items-center gap-3 bg-white rounded-2xl shadow-2xl border border-[#E5E7EB] px-4 py-3 cursor-pointer hover:shadow-xl transition-shadow"
        style={{ minWidth: 220, maxWidth: 300 }}
        onClick={() => dispatch(setStaticSyncMinimized(false))}
        title="Klicken zum Vergrößern"
      >
        <div className="flex-shrink-0">
          {staticSyncPhase === 'running' && staticSyncConnectionLost && <WifiOff size={18} className="text-amber-500" />}
          {staticSyncPhase === 'running' && !staticSyncConnectionLost && <Loader2 size={18} className="animate-spin" style={{ color: aispaceColor }} />}
          {staticSyncPhase === 'done'    && <CheckCircle2 size={18} className="text-green-500" />}
          {staticSyncPhase === 'error'   && <AlertTriangle size={18} className="text-red-500" />}
        </div>

        <div className="flex-1 min-w-0">
          <p className="text-xs font-semibold text-[#111827] truncate">
            {staticSyncPhase === 'running' ? (staticSyncConnectionLost ? t('agentSettings.filesImportReconnecting') : 'Sync läuft…')
              : staticSyncPhase === 'done' ? 'Sync abgeschlossen'
              : 'Sync fehlgeschlagen'}
          </p>
          <p className="text-[11px] text-[#9CA3AF] truncate">{staticSyncSite.site_name}</p>

          {staticSyncPhase === 'running' && (
            <div className="mt-1.5">
              <div className="w-full bg-[#F3F4F6] rounded-full h-1.5 overflow-hidden">
                {pct !== null ? (
                  <div className="h-full rounded-full transition-all duration-500"
                    style={{ width: `${pct}%`, backgroundColor: aispaceColor }} />
                ) : (
                  <div className="h-full rounded-full w-1/2 animate-pulse"
                    style={{ backgroundColor: aispaceColor }} />
                )}
              </div>
              {pct !== null && (
                <p className="text-[10px] text-[#9CA3AF] mt-0.5">
                  {staticSyncProgress.processed}/{staticSyncProgress.total} Dateien · {pct}%
                </p>
              )}
            </div>
          )}
        </div>

        <div className="flex items-center gap-1 flex-shrink-0" onClick={e => e.stopPropagation()}>
          <button onClick={() => dispatch(setStaticSyncMinimized(false))}
            className="p-1 hover:bg-[#F3F4F6] rounded-lg transition-colors" title="Vergrößern">
            <ChevronUp size={14} className="text-[#6B7280]" />
          </button>
          {staticSyncPhase !== 'running' && (
            <button onClick={() => dispatch(clearStaticSync())}
              className="p-1 hover:bg-[#F3F4F6] rounded-lg transition-colors" title="Schließen">
              <X size={14} className="text-[#9CA3AF]" />
            </button>
          )}
        </div>
      </div>
    </div>
  )
}
